const tailLayout = {
  wrapperCol: {
    offset: 8,
    span: 16,
  },
};
const layout = {
  labelCol: {
    span: 8,
  },
  wrapperCol: {
    span: 24,
  },
};

export { layout, tailLayout };
